import { styled } from '@material-ui/core';
import { Typography } from '@room-match/shared-ui-components';
import { COLORS } from 'shared/constants/COLORS';

export const MainContainer = styled('div')(({ theme }) => ({
  background: theme.palette.type === 'dark' ? COLORS.DARK_BACKGROUND : COLORS.WHITE,
  border: theme.palette.type === 'dark' ? '1px solid #2d343e' : '1px solid #cdd9e9',
  borderRadius: 8,
  width: '100%',
  position: 'relative',
  display: 'flex',
  [theme.breakpoints.down('xs')]: {
    padding: 15,
  },
}));

export const Left = styled('div')(({ theme }) => ({
  borderBottomLeftRadius: 8,
  borderTopLeftRadius: 8,
  borderRight: theme.palette.type === 'dark' ? '1px solid #2d343e' : '1px solid #cdd9e9',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  maxWidth: 120,
  width: '100%',
  padding: '20px 10px',
  background: theme.palette.type === 'dark' ? '#10151c' : '#f7f7f7',

  '& .MuiSvgIcon-root': {
    marginBottom: 5,
    width: 24,
    height: 24,
  },
}));

export const Right = styled('div')(({ theme }) => ({
  padding: '20px 30px',
}));

// New Styled Component

export const TextSwitchColor = styled('p')(({ theme, size, withBreakSpaces }: any) => ({
  fontSize: size || 16,
  color: theme.palette.type === 'dark' ? COLORS.WHITE : COLORS.DARK,
  whiteSpace: withBreakSpaces ? 'break-spaces' : undefined,
}));

export const TextGreyColor = styled('p')(({ theme, size }: any) => ({
  fontSize: size || 14,
  color: 'rgb(152, 161, 172)',
}));
